const convertToPrice = (value = 0, withoutFixed = false) => {
  if (value < 1 && value > 0) {
    return `${(value * 100).toFixed(0)}¢`;
  }
  return `$${Number(value || 0).toFixed(withoutFixed ? 0 : 2)}`;
};

export default convertToPrice;
